import { AccessClient } from "./axiosInstance.js";

// 수업 목록 가져오기
export const loadAllCourses = async () => {
  try {
    const response = await AccessClient.get("/api/courses");
    //console.log("response : ", response);
    const {
      status,
      data: { data: courses, message },
    } = response;
    return { status, courses, message };
  } catch (error) {
    //    console.log(error.response);
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

// 특정 수업 정보 가져오기
export const loadCourse = async ({ id }) => {
  try {
    const response = await AccessClient.get(`/api/courses/${id}`);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

// 특정 수업의 특정 주 정보 가져오기
export const loadWeek = async ({ courseId, week }) => {
  try {
    const response = await AccessClient.get(`/api/weeks/${week}`);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    console.log(status);
    console.log(message);

    return { status, message };
  }
};

/**
 * 특정 수업의 특정 주 정보 가져오기
 * @param {*} param0 
 * @returns 
 */
export const saveWeek = async ({ id }) => {
  try {
    const response = await AccessClient.update(`/api/weeks/${id}`);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

/**
 * 동서대 DB 정보를 수업을 생성하기
 * @param {*} createCourse
 * @returns 
 */
export const createCourseWithDSULink = async ({ info, professor, students }) => {
  try {
    let body = {
      info: info,
      professor: professor,
      students: students,
    };

    const response = await AccessClient.post("/api/courses/link", body);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

/**
 * 동서대 DB 정보를 수업을 생성하기
 * @param {*} createCourse
 * @returns 
 */
export const newCourseWithDSULink = async () => {
  try {
    const response = await AccessClient.get("/api/courses/linkNew");
    console.log("linkNew response : ", response);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};